import React, { useState, useEffect, useRef } from 'react';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Functions from '../../api/Functions';
import { waitListConfig } from '../../constants/constants';
import CircleLoader from '../loaders/CircleLoader';

const WaitListConfig = (props) => {
  const { auth, firestore, systemVariables } = props;
  const [waitList, setWaitList] = useState({});
  const [allUsers, setAllUsers] = useState({});
  const [fullUsers, setFullUsers] = useState({});
  const [maxUsers, setMaxUsers] = useState(null);
  const [loading, setLoading] = useState(false);
  const refModal = useRef();

  useEffect(() => {
    let elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  }, []);

  const openConfirmationDialog = () => {
    M.Modal.getInstance(refModal.current).open();
  };

  const closeModal = () => {
    M.Modal.getInstance(refModal.current).close();
  };

  useEffect(() => {
    if (!systemVariables) return;
    setWaitList(systemVariables.WAIT_LIST);
    setAllUsers(systemVariables.ALL_USERS);
    setFullUsers(systemVariables.FULL_USERS);
    setMaxUsers(systemVariables.ALL_USERS.maxUsers);
  }, [systemVariables]);

  const updateSystemVariable = (id, data) => {
    firestore
      .collection('systemVariables')
      .doc(id)
      .set({ ...data }, { merge: true })
      .then(() => M.toast({ html: 'Configuration updated' }))
      .catch((e) => M.toast({ html: e.message ? e.message : 'Something went wrong' }));
  };

  const updateMaxUsers = () => {
    setLoading(true);
    Functions.updateMaxUsers(maxUsers)
      .then(() => M.toast({ html: 'Maximum users updated' }))
      .catch((e) => M.toast({ html: e.message ? e.message : 'Something went wrong' }))
      .finally(() => {
        setLoading(false);
        closeModal();
      });
  };

  const verifyIfInviteCodesWillBeSent = () => {
    if (inviteCodesWillBeSent()) {
      openConfirmationDialog();
    } else {
      updateMaxUsers();
    }
  };

  const inviteCodesWillBeSent = () => {
    const previousLimitWasExceeded = allUsers.currentUsers > allUsers.maxUsers;
    const newLimitIncreased = maxUsers > allUsers.maxUsers;
    const newLimitCoversAllUsers = maxUsers >= allUsers.currentUsers;
    return previousLimitWasExceeded && newLimitIncreased && newLimitCoversAllUsers;
  };

  const renderGlobalUsers = () => (
    <div className="card " style={{ padding: 25 }}>
      <p style={{ fontWeight: 'bold', marginBottom: 25 }}>Global users</p>
      <p style={{ textAlign: 'center', color: 'gray' }}>{`Total Users / Max Users`}</p>
      <p style={{ textAlign: 'center', fontSize: 25 }}>{`${allUsers.currentUsers || ''} / ${allUsers.maxUsers || ''}`}</p>
    </div>
  );

  const renderUserCounters = () => (
    <div className="card" style={{ padding: 30 }}>
      <p style={{ fontWeight: 'bold', marginBottom: 25 }}>Users count</p>
      <UserCount label="Wait List" value={waitList.currentUsers} />
      <Separator />
      <UserCount label="Full Sign Up" value={fullUsers.currentUsers} />
      <Separator />
      <UserCount label="Total" value={allUsers.currentUsers} />
    </div>
  );

  const UserCount = ({ label, value }) => (
    <div className="row">
      <div className="col s6">{label}</div>
      <div className="col s6" style={{ textAlign: 'right' }}>
        {value}
      </div>
    </div>
  );

  const Separator = () => <hr style={{ border: 'none', borderTop: '1px solid whitesmoke' }} />;

  const renderWaitListEnable = () => (
    <div>
      Wait list enabled:
      <div className="row">
        <div className="input-field col s6">
          <label>
            <input name="group1" type="radio" checked={waitList.enable || false} disabled={true} onChange={() => updateSystemVariable(waitListConfig.WAIT_LIST, { enable: !waitList.enable })} />
            <span>Yes</span>
          </label>
        </div>
        <div className="input-field col s6">
          <label>
            <input name="group2" type="radio" checked={!waitList.enable || false} disabled={true} onChange={() => updateSystemVariable(waitListConfig.WAIT_LIST, { enable: !waitList.enable })} />
            <span>No</span>
          </label>
        </div>
      </div>
    </div>
  );

  const renderMaxUsers = () => (
    <div>
      Maximum limit of users:
      <div className="row input-field" style={{ verticalAlign: 'center' }}>
        <input className="col l10 m10 s8" type="text" value={maxUsers || 0} onChange={(e) => setMaxUsers(Number(e.target.value))} />
        <button className="col l2 m2 s4 waves-effect waves-light btn-small" onClick={() => verifyIfInviteCodesWillBeSent()}>
          Update
        </button>
      </div>
    </div>
  );

  const updateConfirmationDialog = () => {
    return (
      <div ref={refModal} id="modalConfirmation" className="modal">
        <div className="modal-content">
          <h5>Are you sure you want to update maximum users?</h5>
          <p>This action will send invite codes to ALL USERS on the waiting list that have not received one (At least {allUsers.currentUsers - allUsers.maxUsers} users will receive a mail or sms)</p>
        </div>
        <div className="modal-footer">
          <a href="#!" onClick={() => updateMaxUsers()} className="modal-close waves-effect btn btn-flat">
            Confirm
          </a>
          <a href="#close" className="modal-close waves-effect btn btn-flat">
            Cancel
          </a>
        </div>
      </div>
    );
  };

  if (!auth.uid) return <Redirect to="/signin" />;
  return (
    <div className="container">
      {updateConfirmationDialog()}
      <div className="title-section">Wait list configuration</div>
      {renderWaitListEnable()}
      <br />
      {renderMaxUsers()}
      {loading && <CircleLoader />}
      <div className="row">
        <div className="col l6 m6 s12" style={{ padding: 15 }}>
          {renderGlobalUsers()}
        </div>
        <div className="col l6 m6 s12" style={{ padding: 15 }}>
          {renderUserCounters()}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    systemVariables: state.firestore.data.systemVariables,
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([{ collection: 'systemVariables' }]), connect(mapStateToProps))(WaitListConfig);
